import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import axiosInstance from '../../headersService'


export const fetchAllYearBranch = createAsyncThunk('fetchAllYearBranch', async (obj, { rejectWithValue }) => {
    try {
        const { data } = await axiosInstance.get(`${process.env.REACT_APP_BACKEND_URL}/api/student/branch/year?type=${obj.type}`)
        return data
    } catch (error) {
        console.log(error)
        return rejectWithValue(error)
    }
})

export const studentBranchYearSlice = createSlice({
    name: 'year',
    initialState: {
        loading: false,
        branch: {},
        error: null
    },
    extraReducers: (builder) => {
        builder.addCase(fetchAllYearBranch.pending, (state, action) => {
            state.loading = true;
        })
        builder.addCase(fetchAllYearBranch.fulfilled, (state, action) => {
            state.loading = false;
            state.branch = action.payload
        })
        builder.addCase(fetchAllYearBranch.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload
        })
    }
})

export default studentBranchYearSlice.reducer